import { createStore } from 'vuex'

export default createStore(
  {
  state: 
  {
    appStarted:false
  },
  mutations: 
  {
    startApp (state) { state.appStarted = true }
  },
  actions: 
  {
    startApp (context) {  context.commit('startApp') }
  },
  modules: 
  {
  }
})
